<div style="display: flex;width:100%;height:100%;font-family: KantarBrown-Regular;
font-size: 0.75rem;" id="chart-divs">
    <div style="width:97%;height:100%;">

        <div class="container" >
            <div *ngFor="let item of items | zip: trendItems; let i = index; trackBy: trackById" class="item" [attr.step]="i"
                [ngClass]="{'new-row': i % 3 === 0}">
                <div class="itemHeader">
                    <div class="itemName">{{ item.item1.widgetName }}</div>

                    <div class="itemIcon">
                        <app-output-icons style="width:100%; display:flex;justify-content: flex-end;" [widgetName]="item.item1.widgetName"
                            [visualization]="item.item1.visualization" [id]="i" [infoIcon]="item.item1.infoIcon"  [data]="item.item1.metric" [trendData]="item.item2.metric" [sort]="item.item1.sort" [isSort]="item.item1.isSort" [sortToggleFromParent]="sortToggle"
                            (iconClicked)="ClickedIconFun($event)" [item]="item.item1" (sortType)="sortWidget($event)" (defaultSortType)="defaultSortWidget($event)"></app-output-icons>
                    </div>
                </div>
                <hr>
                <div class="chart-section">
                    <!-- <ng-container> -->
                    <app-snapshot-chartsparent *ngIf="item.item1.metric.length>0 && showChart" [chart]="item.item1.visualization" [id]="i" [data]="item.item1.metric"
                        [height]="height" [sort]="item.item1.sort" [WidgetDetails]="item.item1"></app-snapshot-chartsparent>
                   
                    <!-- <app-piechart15></app-piechart15> -->
                    <!-- <app-piechart15 *ngIf="item.item1.visualization=='05 Pie'"></app-piechart15>
                    <app-barchart01 *ngIf="item.item1.visualization=='Vertical Bar'"></app-barchart01> -->
                    <!-- </ng-container> -->
                    <!-- <div>
                        <ng-template [id]="i" [ngComponentOutlet]="getComponentByLabel(item.item1.visualization)"></ng-template>
                    </div> -->
                    <!-- <div>
               <ng-template [id]="i" [ngComponentOutlet]="getComponentByLabel('05 Pie')"></ng-template>
            </div> -->
                    <!-- <ng-container *ngTemplateOutlet="dynamicComponent; context: { $implicit: item.item1.visualization, id: i }"></ng-container> -->
                    <!-- <div class="chart-section" #chartContainer></div> -->
                </div>
                <div class="chart-section-text" *ngIf="item.item1.metric.length<1">
                    <div *ngIf="item.item1.metric.length<1 && item.item1.noData==undefined">Widget is not configured.</div>
                    <div *ngIf="item.item1.metric.length<1 && item.item1.noData==true">No data for current selections.</div>
                </div>
            </div>
        </div>


    </div>
    <div style="width:3%;height:100%;" *ngIf="showPageNav">
        <app-outputview-pagination (paginationCounter)="paginationCounterFun($event)"
            [totalPages]="pagesPerSection"></app-outputview-pagination>

    </div>
</div>

<ng-template #dynamicComponent let-visualization let-id="id">
    <ng-container *ngComponentOutlet="getComponentByLabel(visualization)"></ng-container>
</ng-template>